import { JSX } from 'react'

import http from '@/lib/request.js'

import * as alchemy from '@/lib/alchemy.js'

import * as detective from '@/lib/detective.js'

import * as token_storage from '@/storage/token.js'




export enum TStorageFields
{
	value = 'value',
	refresh = 'refresh',
	expire = 'expire',

}


export type TRawDocType = {
	value  : string
	refresh: string
	expire : string

}




export const update = alchemy.closure(
	{ timer: 0 },

	function (doc: TRawDocType): void
	{
		http.token = doc.value

		if (this.timer > 0)
		{
			clearTimeout(this.timer)

		}

		this.timer = setTimeout(
			async () =>
			{
				let v = await token_storage.update(doc.refresh)

				update(v)
				update_storage(v)

			},

			new Date(doc.expire).valueOf() - new Date().valueOf(),

		)

	},

)


export function update_storage (doc: TRawDocType): void
{
	localStorage.setItem(TStorageFields.value, doc.value)
	localStorage.setItem(TStorageFields.refresh, doc.refresh)
	localStorage.setItem(TStorageFields.expire, doc.expire)


}




export function retrieve_storage (): null | TRawDocType
{
	let doc = {
		value  : localStorage.getItem(TStorageFields.value),
		refresh: localStorage.getItem(TStorageFields.refresh),
		expire : localStorage.getItem(TStorageFields.expire),

	}

	let a = detective.is_empty(doc.value)
	let b = detective.is_empty(doc.refresh)
	let c = detective.is_empty(doc.expire) || new Date() > new Date(doc.expire)

	if (a || b || c)
	{
		return null

	}

	return doc as TRawDocType

}




export default function
(
	props: {
		children(dispatch: () => Promise<void>): JSX.Element

	},

)
:	JSX.Element
{
	let doc = retrieve_storage()

	if (detective.is_exist(doc) )
	{
		update(doc)

	}

	let dispatch = async (): Promise<void> =>
	{
		let v = await token_storage.create()

		update(v)
		update_storage(v)

	}

	return <>{props.children(dispatch)}</>


}
